export default __webpack_public_path__ + "124e16e5b8e7472ce5526bfeb2debcd7.webp";